const selCiudad = (list1, argsSelDpto, codigoCiudadUA) => {
  // console.log(list1, argsSelDpto, codigoCiudadUA)
  let listCiu = []
  listCiu.push({nombreCiudad: "Todas..."})
  if(argsSelDpto._id){
    let miLista = document.getElementById("miLista");
    //Ciudades del Dpto seleccionado
    let indexSearchD = list1.findIndex(elementoD => elementoD._id===argsSelDpto._id)
    // console.log(indexSearchD)
    if(indexSearchD!==-1){
      let indexSearchC = -1
      if(codigoCiudadUA==="Todas..."){
        listCiu = listCiu.concat(list1[indexSearchD].ciudades);
        miLista = document.getElementById("miLista1");
        if(miLista){
          let existe = "N"
          indexSearchC = listCiu.findIndex(elementoC => elementoC.codigoCiudad===miLista.options[miLista.selectedIndex].value)
          if(indexSearchC!==-1){
            existe = "S"
          }
          if(existe==="N"){
            miLista.options.selectedIndex = 0
          }
        }
      }else{
        listCiu = list1[indexSearchD].ciudades.filter(elemento => elemento.codigoCiudad===codigoCiudadUA)
      }
    }
  }else{
    if(argsSelDpto._id===""){
      let miLista = document.getElementById("miLista");
      miLista.options.selectedIndex = 0
      miLista = document.getElementById("miLista1");
      miLista.options.selectedIndex = 0
    }
  }
// console.log(listCiu)
  let colecc = {listCiu}

  return colecc
}

export default selCiudad
